import { ISubscriptionWithDescription } from "~/util/providers/share-position/interfaces";
import { IState } from "../store";

export function selectSubscriptions(state: IState): Array<ISubscriptionWithDescription> {
	return state.sharePosition.subscriptions;
}

export function selectActiveSubscription(state: IState): string {
	return state.sharePosition.activeSubscription;
}

export function selectActiveTab(state: IState): IState["sharePosition"]["activeTab"] {
	return state.sharePosition.activeTab;
}
